export default "__VITE_ASSET__CVCqF6nK__"